//#region src/speech/speech-model.ts
var SPEECH_RATE_RANGE = [.5, 2];
var SPEECH_PITCH_RANGE = [.5, 1.5];
var DEFAULT_SPEAKER_SETTINGS = {
	rate: 1,
	pitch: 1,
	volume: 1
};
/** A `say()` before the first gesture is kept this long and spoken after the unlock. */
var SPEECH_PENDING_MAX_AGE_MS = 5e3;
//#endregion
export { DEFAULT_SPEAKER_SETTINGS, SPEECH_PENDING_MAX_AGE_MS, SPEECH_PITCH_RANGE, SPEECH_RATE_RANGE };
